import { createSlice } from '@reduxjs/toolkit';
import { defaultShippingAuctionsSlice } from './shippingAuctions.types';
import { fetchShippingAuctions } from './shippingAuctions.actions';

const shippingAuctionsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchShippingAuctions.pending, (slice, { meta: { arg } }) => {
            slice.error[arg.status] = '';
        });
        builder.addCase(fetchShippingAuctions.fulfilled, (slice, { meta: { arg }, payload }) => {
            slice.catalogs[arg.status] = {
                auctions: payload.catalogs,
                totalCount: payload.total,
            };
        });
        builder.addCase(fetchShippingAuctions.rejected, (slice, { error, meta: { arg } }) => {
            slice.error[arg.status] = error.message;
        });
    },
    initialState: defaultShippingAuctionsSlice,
    name: 'shippingAuctions',
    reducers: {},
});

export const { reducer: shippingAuctionsReducer } = shippingAuctionsSlice;
